export default __webpack_public_path__ + "static/media/photo--sm--102.efc9c2df.jpg";